import script from "./Description.step.vue?vue&type=script&setup=true&lang=js"
export * from "./Description.step.vue?vue&type=script&setup=true&lang=js"

import "./Description.step.vue?vue&type=style&index=0&id=6230adc4&lang=scss"

const __exports__ = script;

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QFooter,QBtn});
